<template>
    <div>
        Message Tracker
    </div>
</template>